import { withStyles, Button } from "@material-ui/core";
import * as React from "react";
import { createFragmentContainer } from "react-relay";

// util
import { UserFlags, isFlagSet, FlagNamespaces } from "@clockwise/client-commons/src/util/flags";

// mutations
import { updateFlagsForUser } from "@mutations";

// components
import { H2 } from "@components/ui";

// internal
import { IProps, IState } from "./TutorialTeamSharedCalendar.d";
import { styles } from "../TutorialBox.styles";
import { fragments } from "./TutorialTeamSharedCalendar.gql";
import { articleUrls } from "@clockwise/client-commons/src/constants/help-center";
import { track, TrackingEvents } from "@clockwise/web-commons/src/util/analytics.util";

// TODO: abstract the logic out here between shared calendar / team health
//       this should be done as part of some larger ui abstraction
export class TutorialTeamSharedCalendarComponent extends React.Component<IProps, IState> {
  private removalTimeout: ReturnType<typeof setTimeout>;

  constructor(props: IProps) {
    super(props);

    this.state = {
      isPendingRemoval: false,
    };
  }

  public componentWillUnmount() {
    this.clearTimeouts();
  }

  private onSetFlagSuccess = () => {
    this.setState({ isPendingRemoval: false });
  };

  private onSetFlagFailure = () => {
    this.setState({ isPendingRemoval: false });
  };

  private setFlag = () => {
    updateFlagsForUser(
      this.props.relay.environment,
      {
        flagNamespace: FlagNamespaces.ChromeExtension,
        flagNames: [UserFlags.Onboarding.TeamCalendarSharedEvent.name],
        enable: true,
      },
      this.onSetFlagSuccess,
      this.onSetFlagFailure,
    );
  };

  private onClickLearnMore = () => {
    window.open(articleUrls.teamCalendar, "_blank");
    track(TrackingEvents.EVENT.TEAM_TIP_LEARN_MORE);
  };

  // ~-~-~-~-~-~-~-
  // Removal Animations
  // ~-~-~-~-~-~-~-
  private clearTimeouts = () => {
    clearTimeout(this.removalTimeout);
  };

  private delayedRemove = () => {
    this.removalTimeout = setTimeout(() => this.setFlag(), 500);
  };

  private startRemoval = () => {
    this.setState({ isPendingRemoval: true }, () => this.delayedRemove());
    track(TrackingEvents.EVENT.TEAM_TIP_DISMISSED);
  };

  ///////////////
  // Rendering //
  ///////////////
  public render() {
    const { flagsErrorable, classes } = this.props;
    const { isPendingRemoval } = this.state;

    if (
      flagsErrorable.__typename === "GraphEntityError" ||
      isFlagSet(UserFlags.Onboarding.TeamCalendarSharedEvent.name, flagsErrorable)
    ) {
      return null;
    }

    return (
      <div className={classes[!isPendingRemoval ? "container" : "hidden"]}>
        <H2 style={styles.header}>
          Clockwise now syncs your OOO and WFH events to your team calendars
        </H2>
        <div className={classes.body}>
          All you need to do is update your calendar and we'll keep your teammates informed.
        </div>
        <div style={{ display: "flex" }}>
          <Button className={classes.button} onClick={this.startRemoval} variant="outlined">
            Got it
          </Button>
          <Button
            style={{ marginLeft: 8 }}
            className={classes.button}
            onClick={this.onClickLearnMore}
            variant="text"
          >
            Learn More
          </Button>
        </div>
      </div>
    );
  }
}

/////////////////
// With Styles //
/////////////////

export const TutorialTeamSharedCalendarWithStyles = withStyles(styles)(
  TutorialTeamSharedCalendarComponent,
);

///////////
// Relay //
///////////

export const TutorialTeamSharedCalendar = createFragmentContainer(
  TutorialTeamSharedCalendarWithStyles,
  fragments,
);
